import React, { useEffect } from 'react'
import { Popup, ToastContext, Button } from '@pmi/pmi-iqos-ds-react'
import { goTo, Routes } from '@pmi/pmi-iqos-shared-react'

const ModalFraud = ({ isOpen, translations }) => {
  const popupToast = ToastContext.getContextActions().popupToast

  useEffect(() => {
    if (isOpen) {
      popupToast({
        title: translations.tk_fraudLabel,
        autoDismiss: true,
        actions: [
          <Button
            key={0}
            fullWidth
            variant={Button.variants.primary}
            text={translations.tk_fraudButton}
            onClickHandler={onCloseModalFraud}
            data-testing="Fraud_Button_Close"
          />
        ],
        onClose: () => {
          onCloseModalFraud()
        }
      })
    }
  }, [isOpen])

  const onCloseModalFraud = () => {
    goTo(Routes.main)
  }

  return (
    <Popup
      isOpen={isOpen}
      blocking
      darkMode
      fullScreen
      data-testing-prefix="Fraud"
    />
  )
}

export default ModalFraud
